import React from 'react';
import PropTypes from 'prop-types';
import {Heading, RichContent} from "../elements";
import {ServicesDescriptionElement} from "../elements/ServicesDescriptionElement";

export const ServicesDescriptionComponent = (props) => {
	return(
		<section className="kiwi-services--description">
			<div className="container">
                <div className="row">
                    <div className="col-xs-12">
						<Heading content={props.header}/>
					</div>
					<div className="col-xs-12">
						<RichContent dangerous={props.intro} />
					</div>
					<div className="row">
						<ul className="services--description-list list-unstyled">
							{ props.services.map((service, i) => {
								return <ServicesDescriptionElement key={i}
											description={service.description}
											details={service.details}
											title={service.title}
											linkColor={props.linkColor}

										/>
								})
							}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

ServicesDescriptionComponent.propTypes = {
	header: PropTypes.string,
	introduction: PropTypes.string,
	services: PropTypes.array
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/ServicesDescriptionComponent.js